import { render } from "./day.vue?vue&type=template&id=af4b96d0&scoped=true"
import script from "./day.vue?vue&type=script&lang=js"
export * from "./day.vue?vue&type=script&lang=js"

import "./day.vue?vue&type=style&index=0&id=af4b96d0&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4b96d0"]])

export default __exports__